import {
    Box,
    Card,
    Stack,
    styled,
    Table,
    TableRow,
    useTheme,
} from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import AppPagination from 'components/AppPagination';
import Scrollbar from 'components/ScrollBar';
import columnShape from 'page-sections/purchased-workshops/columnShape';
import HeadingArea from 'page-sections/purchased-workshops/heading-area';
import SearchArea from 'page-sections/purchased-workshops/search-area';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    useAsyncDebounce,
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable,
} from 'react-table';
import axiosInstance from 'utils/axios';
const HeadTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    '&:first-of-type': {
        paddingLeft: 24,
    },
    '&:last-of-type': {
        paddingRight: 24,
    },
}));
const BodyTableCell = styled(HeadTableCell)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: 13,
    fontWeight: 500,
    borderBottom: `1px solid ${theme.palette.divider}`,
}));
const PurchasedWorkshops = () => {
    const navigate = useNavigate();
    const [listData, setListData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const theme = useTheme();
    const columns = useMemo(() => columnShape, []);
    const handleDetail = (data) => {
        navigate(`/dashboard/operator/purchased-workshops/${data.id}`);
    };
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        pageOptions,
        gotoPage,
        state,
        setGlobalFilter,
    } = useTable(
        { columns, data: listData },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
    ); // handle change pagination

    const getData = async (param) => {
        setExportData([]);
        await axiosInstance
            .get(`/api/prv/operator/workshops`)
            .then(({ data }) => {
                setListData(data);
                setExportData(
                    data.map((item, index) => ({
                        No: index + 1,
                        Woskhop_Name: item.name,
                        Workshop_Type: item.type.label,
                        Individu_Paid: item.paidInvoiceCount,
                        Individu_Waiting: item.pendingInvoiceCount,
                        Group_Invoiced: item.groupInvoicedCount,
                        Group_GL_Uploaded: item.groupGLUploadedCount,
                    })),
                );
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);
    const handleChange = (_, currentPageNo) => gotoPage(currentPageNo - 1); // handle change for tab list
    const [searchValue, setSearchValue] = useState(state.globalFilter);
    const handleSearch = useAsyncDebounce(
        (value) => setGlobalFilter(value || undefined),
        200,
    );

    return (
        <Box pt={2} pb={4}>
            <Card
                sx={{
                    py: 2,
                }}
            >
                <Box px={3}>
                    <HeadingArea />

                    <SearchArea
                        value={searchValue}
                        onChange={handleSearch}
                        setValue={setSearchValue}
                        data={exportData}
                    />
                </Box>
                <Scrollbar autoHide={true}>
                    <Table
                        {...getTableProps()}
                        sx={{
                            minWidth: 900,
                        }}
                    >
                        <TableHead
                            sx={{
                                borderBottom: `1px solid ${theme.palette.divider}`,
                            }}
                        >
                            {headerGroups.map((headerGroup, index) => (
                                <TableRow
                                    key={index}
                                    {...headerGroup.getHeaderGroupProps()}
                                >
                                    {headerGroup.headers.map(
                                        (column, index) => (
                                            <HeadTableCell
                                                key={index}
                                                {...column.getHeaderProps(
                                                    column.getSortByToggleProps(),
                                                )}
                                                sx={{
                                                    paddingY: 0,
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    borderBottom: 0,
                                                    width: column.width,
                                                    color: 'text.secondary',
                                                    minWidth: column.minWidth,
                                                    maxWidth: column.maxWidth,
                                                    '&:last-child': {
                                                        textAlign: 'center',
                                                    },
                                                }}
                                            >
                                                {column.render('Header')}
                                            </HeadTableCell>
                                        ),
                                    )}
                                </TableRow>
                            ))}
                        </TableHead>

                        <TableBody {...getTableBodyProps()}>
                            {page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <TableRow
                                        {...row.getRowProps()}
                                        key={index}
                                    >
                                        {row.cells.map((cell, index) => {
                                            return (
                                                <BodyTableCell
                                                    key={index}
                                                    {...cell.getCellProps()}
                                                >
                                                    {cell.render('Cell', {
                                                        handleDetail,
                                                    })}
                                                </BodyTableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Scrollbar>

                <Stack alignItems="center" marginY={4}>
                    <AppPagination
                        shape="rounded"
                        onChange={handleChange}
                        count={pageOptions.length}
                    />
                </Stack>
            </Card>
        </Box>
    );
};

export default PurchasedWorkshops;
